import * as React from "react";
import { ForwardedRef, forwardRef, useCallback } from "react";
import styled from "@mui/material/styles/styled";
import { IconButton } from "@mui/material";
import { useNavigation } from "../../state/navigationContext";
import clsx from "clsx";
import { ReactComponent as UndoIcon } from "../../assets/undoIcon.svg";
import { PatientColorMap } from "../../layout/patientColorMap";
import { onRtl } from "fe-web-components/rtl/rtlStyles";
import { FirstTimeShowTooltip } from "./firstTimeShowTooltip";
import { PatientThemeImage } from "../../themes/PatientThemeImage";

//region [[ Styles ]]

const UndoQuestionView = styled(IconButton)(({ theme }) => ({
  marginRight: "5px",
  ...onRtl({
    transform: "rotateY(180deg)",
  }),
  "&.undo-question,&.undo-question:hover, &.undo-question:focus": {
    background: "transparent",
    padding: "12px",
    boxShadow: "unset",
  },
}));

const ColoredIcon = styled(UndoIcon)({
  "& path": {
    fill: PatientColorMap.Undo,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface UndoQuestionProps {
  className?: string;
  onUndo: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SHOW_POPUP_TOOLTIP_STORAGE_KEY = "x-undo-tootip-dismissed";

export const UndoQuestion = forwardRef(
  ({ onUndo, ...props }: UndoQuestionProps, ref: ForwardedRef<any>) => {
    const { themeSettings } = useNavigation();

    const onUndoQuestion = useCallback(() => {
      onUndo();
    }, [onUndo]);

    return (
      <FirstTimeShowTooltip tooltipKey={"UNDO_TOOLTIP_TEXT"}>
        <UndoQuestionView
          className={clsx(props.className, "undo-question")}
          ref={ref}
          onClick={onUndoQuestion}
        >
          {/* Support older code where we input the icon using <img src=></img> */}
          {themeSettings?.arrowIcon && (
            <PatientThemeImage source={themeSettings?.arrowIcon} />
          )}
          {!themeSettings?.arrowIcon && <ColoredIcon />}
        </UndoQuestionView>
      </FirstTimeShowTooltip>
    );
  },
);
